import React from 'react';
import DemographicData from '../DemographicData/DemographicData';

const BeneficiaryDataLoaderReport = () => {
  return (
    <div>
      <DemographicData />
    </div>
  );
};

export default BeneficiaryDataLoaderReport;